// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nsKk","newExpiryDate":"styles_newExpiryDate__2n5Mi","footer":"styles_footer__3b9yI"};